import React from "react";
import { Mail, Phone, MapPin, Facebook, Instagram } from "lucide-react";
import ApplyForm from "@/components/ApplyForm";
import { useSiteContent } from "@/lib/siteContent";
import { contactDefaults } from "@/pages/navPageDefaults";

export default function Contact() {
  const content = useSiteContent();
  if (!content) return <div className="min-h-[60vh]" />;
  const c = { ...contactDefaults, ...(content.contact || {}) };
  return (
    <div>
      <ApplyForm
        type="contact"
        testId="contact-page"
        title={c.title}
        subtitle={c.subtitle}
        image={c.image}
        blurb={c.blurb}
        messageLabel="How can we help?"
      />
      <div className="max-w-3xl mx-auto px-6 md:px-12 pb-24 -mt-8">
        <div className="grid sm:grid-cols-3 gap-6">
          {[
            { icon: Mail, label: "Email", value: c.email || contactDefaults.email },
            { icon: Phone, label: "Phone", value: c.phone || contactDefaults.phone },
            { icon: MapPin, label: "Base", value: c.base || contactDefaults.base },
          ].map((x, i) => (
            <div key={x.label} className="bg-navy-paper border border-slate-800 p-5 text-center" data-testid={`contact-detail-${i}`}>
              <x.icon className="w-6 h-6 text-gold mx-auto mb-2" />
              <div className="text-slate-500 text-[10px] uppercase tracking-widest">{x.label}</div>
              <div className="text-white text-sm mt-1">{x.value}</div>
            </div>
          ))}
        </div>
        {(c.facebook || c.instagram) && (
          <div className="flex justify-center gap-4 mt-8" data-testid="contact-socials">
            {c.facebook && <a href={c.facebook} target="_blank" rel="noreferrer" data-testid="contact-facebook" className="w-11 h-11 border border-slate-700 hover:border-gold flex items-center justify-center text-slate-300 hover:text-gold transition-colors"><Facebook className="w-5 h-5" /></a>}
            {c.instagram && <a href={c.instagram} target="_blank" rel="noreferrer" data-testid="contact-instagram" className="w-11 h-11 border border-slate-700 hover:border-gold flex items-center justify-center text-slate-300 hover:text-gold transition-colors"><Instagram className="w-5 h-5" /></a>}
          </div>
        )}
      </div>
    </div>
  );
}
